export class DetectActionData {
    public hostname: string[] = [];
    public service: MCRedirectSubmitUrl | null = null;
}

export class DriversInstallActionData {
    public hostname: string[] = [];
    public idconfig: number = 0;
}

export class RestorePointActionData {
    public hostname: string[] = [];
}

export class BackupAllDriverActionData {
    public hostname: string[] = [];
}

export class MonitoringActionData {
    public hostname: string[] = [];
}

export class WebSocketBackupDriverActionData {
    public hostname: string[] = [];
    public hid: string = "";
    }

export class WebSocketBackupListDriverActionData {
    public hostname: string = "";
    public hidlist: string[] = [];
    }

export class WebSocketRestoreDriverActionData {
    public hostname: string = "";
    public hid: string = "";

    }

export class WebSocketRestoreListDriverActionData {
    public hostname: string = "";
    public hidlist: string[] = [];
    }

export class WebSocketRemoveDriverBackupActionData {
    public hostname: string = "";
        public hidlist:string[]=[];
    }

export class WebSocketRestoreLastDriverActionData {
    public hostname: string = "";
        public  hid:string="";
    }

export class WebSocketGetDeviceListActionData {
    public hostname: string = "";
    }

export class WebSocketGetBackupListActionData {
    public hostname: string ="";
}

export class ChangeLangueActionData {
    public hostname: string = "";
    public lan: string = "";
}


export class WebSocketDCDeviceElemResponse {
    public constructor(public driverdate: number = 0,
        public driverversion: string = "",
        public entrydriver: string = "",
        public exist: boolean = false,
        public hid: string = "",
        public infpath: string = "",
        public namematos: string = "") {

        }
}

export class WebSocketGetDeviceListResponse 
{
        public backupliste: WebSocketDCDeviceElemResponse[] = [];
}

export class WebSocketGetBackupListResponse 
{
        public backupliste: WebSocketDCDeviceElemResponse[] = [];
}

export enum AppCloudAction { DetectConfig=1,DriversInstall=2,RestorePoint=3,BackupAllDriver=4,Monitoring=5 };
export enum MCRedirectSubmitUrl { DEFAULT = 0, CONFIG = 1, DRIVERS = 2, BSOD = 3, MONITORING = 4 };

export class WebSocketIndex {
    public isconnect: boolean = false;
    public userid: number = 0;
    public hostname: string = "";
    public signalrid: string = "";
    public versionagent: string = "";
    public urlconfig: string = "";
}
